import { Injectable } from '@angular/core';

@Injectable()
export class UtilidadesService {

  constructor() { }

  /**
   * Convierte una fecha de formato "YYYY-mm-dd" a un timestamp 
   * @param fecha Debe de estar con el siguiente formato 
   * @returns Devuelve un objeto con dos valores, el inicio y el fin del día
   */
  convertirFechaTimestamp(fecha:string){
    let fechas:any = {};

    // Separa la fecha usando los guines
    let fechaSeparada = fecha.split('-');
    // Crea una nueva instancia de un objeto fecha con lo proporcionado
    let objFecha:Date = new Date(Number(fechaSeparada[0]), Number(fechaSeparada[1]) - 1, Number(fechaSeparada[2]));

    // Asigna el inicio y el fin del día de acuerdo a la fecha proporcionada en formato de timestamp
    fechas['inicioDelDia'] = objFecha.setHours(0,0,0).valueOf();
    fechas['finDelDia'] = objFecha.setHours(23,59,59,999).valueOf();

    return fechas;
  }

  scapeDoubleQuotes(input: string): string {
    return input.replace(/"/g, "'");
  }


  getInfoUnidades(cotizacion: any) {
    const unidades: string[] = [];
    if (cotizacion && cotizacion.combinacion && cotizacion.combinacion.combinacion) {
      const combinacion = cotizacion.combinacion.combinacion;
      Object.keys(combinacion).forEach(key => {
        if (combinacion[key] > 0) {
          unidades.push(`${key} x${combinacion[key]}`);
        }
      });
    }
    return unidades.join(', ');
  }

  getTimeSince(fecha_expiracion: any) {
    const end = new Date(fecha_expiracion);
    const now = new Date();
    const _second = 1000;
    const _minute = _second * 60;
    const _hour = _minute * 60;
    const _day = _hour * 24;

    const distance = now.getTime() - end.getTime();
    if (distance < 0) return 'Caducada';

    const days = Math.floor(distance / _day);
    const hours = Math.floor((distance % _day) / _hour);
    const minutes = Math.floor((distance % _hour) / _minute);
    const seconds = Math.floor((distance % _minute) / _second);

    let remainingTime = '';
    if (days > 0)    remainingTime += days + 'd ';
    if (hours > 0)   remainingTime += hours + 'h ';
    if (minutes > 0) remainingTime += minutes + 'm ';
    if (remainingTime === '') remainingTime = seconds + 's';
    return remainingTime;
  }

  getRemainingTime(fecha_aceptacion: any) {
    if (!fecha_aceptacion) return 'Caducada';

    const end = new Date(fecha_aceptacion);
    const now = new Date();
    const _second = 1000;
    const _minute = _second * 60;
    const _hour = _minute * 60;
    const _day = _hour * 24;

    const fechaExpiracion = end.getTime() + _day;
    const distance = fechaExpiracion - now.getTime();
    if (distance < 0) return 'Caducada';

    const days = Math.floor(distance / _day);
    const hours = Math.floor((distance % _day) / _hour);
    const minutes = Math.floor((distance % _hour) / _minute);
    const seconds = Math.floor((distance % _minute) / _second);

    let remainingTime = '';
    if (days > 0)    remainingTime += days + 'd ';
    if (hours > 0)   remainingTime += hours + 'h ';
    if (minutes > 0) remainingTime += minutes + 'm ';
    if (remainingTime === '') remainingTime = seconds + 's';
    return remainingTime;
  }


}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/services/utilidades.service.ts